import React from "react";
import "./uploader.scss";
import { Icon } from "@iconify/react";
import {  postAPI } from '../../api/index'
import { REACT_APP_CANDIDATE_FREELANCER} from "../../utils/common";
// import { Upload } from "@progress/kendo-react-upload";
import {
  loadMessages,
} from "@progress/kendo-react-intl";
import bgMessages from "./bg.json";

loadMessages(bgMessages, "bg-BG");

interface Props {
  batch?: boolean;
  multiple?: boolean;
  defaultFiles?: any;
  withCredentials?: boolean;
  saveUrl?: string;
  removeUrl?: string;
  onAdd?: any;
  uploadFile?: any;
  upload?: any;
  error?: boolean;
  message?: string;
  errorMessage?: string;
  resume?: string | null;
  DownloadresumeName?:string | null;
}

const Uploader: React.FC<Props> = ({
  batch,
  multiple,
  defaultFiles,
  saveUrl,
  withCredentials,
  removeUrl,
  onAdd,
  uploadFile,
  upload,
  error,
  message,
  errorMessage,
  resume,DownloadresumeName,
  ...rest
}) => {
    

  

const downloadHandle=(name:any)=>{
     
  const fileName=DownloadresumeName;
  let value = {
    "action":"getObject",
    "filename":fileName,
    "bucketName":"ellow-prod-doc-upload",
  };
  postAPI(REACT_APP_CANDIDATE_FREELANCER+'/resume-signed-url',value).then((data) => {
    let signedUrl = data.url;
  const fileName=decodeURIComponent(name.slice(36, name.length))  
  
  fetch(signedUrl).then(response => {
    response.blob().then(blob => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download =fileName;
        alink.click();
    })
})
});
}
   
  return (
    <div className="uploader">
      <div className="uploader">
        <div className="k-widget k-upload">
          <div className="k-dropzone">
            {!resume ? <div className="k-upload-button">
               <input
                type="file"
                id="img"
                name="img"
                accept=".pdf,.doc,.docx"
                onChange={(e) => uploadFile(e)}
              />
              Upload Resume
            </div> 
            : <div>
                <div className="d-flex-wrap"><div className="greenIcon"><Icon icon="bi:file-earmark-check-fill"/></div> <p onClick={()=>downloadHandle(DownloadresumeName)}>{resume}</p></div>
                  <div className="re-upload">
                  <input
                    type="file"
                    id="img"
                    name="img"
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => uploadFile(e)}
                  />
                  Update Resume
                </div>
               </div> }
            <div className="k-dropzone-hint">
              Supported Formats: doc, docx, pdf, to 2 MB
            </div>
            {upload && !error &&  <div className="k-dropzone-hint success">{message}</div>}
            {!upload && !error &&  <div className="k-dropzone-hint success">{message}</div>}
            {error &&  <div className="k-dropzone-hint error">{message}</div>}
            {errorMessage !== '' &&  <div className="k-dropzone-hint error">Field is required*</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Uploader;
